import Base from '../../_config/base';

class Accordion extends Base {
  constructor(el) {
    super(el);
    const allItems = [...el.querySelectorAll('.accordion__item')];

    const showMoreButton = el.querySelector('.showMoreBtn');
    const showLessButton = el.querySelector('.showLessBtn');

    allItems.forEach((item) => { item.onclick = () => { item.classList.toggle('accordion__open'); }; });

    if (showMoreButton && showLessButton) {
      showMoreButton.onclick = () => {
        showMoreButton.classList.toggle('hidden');
        showLessButton.classList.toggle('hidden');
        allItems.forEach((item) => item.classList.remove('hidden'));
      };

      showLessButton.onclick = () => {
        showMoreButton.classList.toggle('hidden');
        showLessButton.classList.toggle('hidden');
        allItems.forEach((item, index) => {
          if (index >= el.getAttribute('data-limit')) {
            item.classList.add('hidden');
          }
        });
      };
    }
  }
}

Accordion.className = 'Accordion';
export default Accordion;
